import { useEffect, useState } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
//import SearchBox from 'components/common/SearchBox';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useNavigate, useParams } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationTotalStandalone,
  PaginationProvider,
  PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Dropdown, Alert, Spinner } from 'react-bootstrap';
import Badge from 'components/base/Badge';
import FilterTab from 'components/common/FilterTab';
import moment from 'moment';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import useAdvanceTable from 'hooks/useAdvanceTable';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import FeatherIcon from 'feather-icons-react';
import Swal from 'sweetalert2';
import { CustomSortCaret } from 'helpers/ui-utils';
import { getItemStocks, getItem, deleteItemStocks } from 'api/api';

const breadcrumbItems = [
  {
    label: 'Items',
    url: '/weapons/weapons'
  },
  {
    label: 'Stocks',
    active: true
  }
];

const StockWeapon = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [error, setError] = useState([]);
  const [total, setTotal] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [itemName, setItemName] = useState(null);
  const [sortColumn, setSortColumn] = useState('desc');
  const [columnName, setColumnName] = useState('id');
  const { id } = useParams();

  useEffect(() => {
    loadData();
    loadItem(id);
  }, [id]);

  const loadData = () => {
    setError([]);
    setLoading(true);

    getItemStocks(id)
      .then(response => {
        setData(response.data.data);
        setTotal(response.data.data.length);
      })

      .catch(err => {
        console.log(err.response);
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const loadItem = id => {
    setError([]);
    setLoading(true);

    getItem(id)
      .then(async response => {
        const data = response.data.data;
        setItemName(data.name);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const CustomSortCaretUpdatedByOrder = (order, dataField) => {
    if (columnName === 'id')
      return (
        <span className="custom-sort-cart">
          <div style={{ display: 'inline-block' }}>
            ▲
            <br />▼
          </div>
        </span>
      );
    else if (sortColumn === 'asc')
      return (
        <span className="custom-sort-cart">
          <div style={{ display: 'inline-block' }}>
            <div style={{ display: 'inline-block' }}> ▲ </div>
            <br />
            <div style={{ display: 'inline-block', visibility: 'collapse' }}>
              ▼
            </div>
          </div>
        </span>
      );
    else if (sortColumn === 'desc')
      return <span className="custom-sort-cart">▼</span>;
    return null;
  };

  const columns = [
    {
      dataField: 'epc',
      text: 'EPC',
      sortCaret:
        columnName === 'epc' ? CustomSortCaretUpdatedByOrder : CustomSortCaret,
      headerStyle: { width: '10%', fontSize: '13px' },
      sort: true,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <>{row.epc.slice(-8)}</>;
      }
    },
    {
      dataField: 'serial_number',
      text: 'SERIAL NO',
      sortCaret:
        columnName === 'serial_number'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      headerStyle: { width: '20%', fontSize: '13px' },
      sort: true,
      style: {
        fontSize: '12px',
        color: 'phoenix-gray-1100',
        fontWeight: 'bold'
      }
    },

    // {
    //   dataField: 'tid',
    //   text: 'TID',
    //   sortCaret:
    //     columnName === 'tid' ? CustomSortCaretUpdatedByOrder : CustomSortCaret,
    //   headerStyle: { width: '10%', fontSize: '13px' },
    //   sort: true,
    //   style: {
    //     fontSize: '12px',
    //     color: 'phoenix-gray-1100',
    //     fontWeight: 'bold'
    //   },
    //   formatter: (cell, row) => {
    //     return <>{row.epc.slice(-8)}</>;
    //   }
    // },

    // {
    //   dataField: 'cfrn',
    //   text: 'CANADIAN FIREARMS REG NR',
    //   sortCaret:
    //     columnName === 'cfrn' ? CustomSortCaretUpdatedByOrder : CustomSortCaret,
    //   headerStyle: { width: '20%', fontSize: '13px' },
    //   sort: true,
    //   style: {
    //     fontSize: '12px',
    //     color: 'phoenix-gray-1100',
    //     fontWeight: 'bold'
    //   }
    // },

    {
      dataField: 'added_time',
      text: 'CREATED DATE',
      sortCaret:
        columnName === 'added_time'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      headerStyle: { width: '20%', fontSize: '13px' },
      sort: true,
      style: {
        fontSize: '12px',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <>{moment(row.added_time).format('MM-DD-YYYY')}</>;
      }
    },

    {
      dataField: 'status',
      text: 'STATUS',
      sortCaret:
        columnName === 'status'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      sort: true,
      headerStyle: { width: '20%', fontSize: '13px' },
      style: {
        fontSize: '12px',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        if (row.status.name === 'In Stock') {
          return (
            <Badge
              bg={'success'}
              variant="phoenix"
              iconPosition="end"
              className="fs-10"
              icon={<FeatherIcon icon={'check'} size={12} className="ms-1" />}
            >
              {row.status.name}
            </Badge>
          );
        } else {
          return (
            <Badge
              bg={'danger'}
              variant="phoenix"
              iconPosition="end"
              className="fs-10"
              icon={<FeatherIcon icon={'info'} size={12} className="ms-1" />}
            >
              {row.status.name}
            </Badge>
          );
        }
      }
    },

    {
      dataField: 'actions',
      formatter: (cell, row) => (
        <div className="table-action-button">
          <RevealDropdownTrigger>
            <RevealDropdown onSelect={eventKey => handleSelect(row, eventKey)}>
              <Dropdown.Item eventKey={`edit:${row.id}`}>Edit</Dropdown.Item>
              <Dropdown.Divider />

              <Dropdown.Item
                key={`${row.id}`}
                className="text-danger"
                eventKey={`delete:${row.id}`}
              >
                Delete
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item eventKey={`logs:${row.id}`}>Logs</Dropdown.Item>
            </RevealDropdown>
          </RevealDropdownTrigger>
        </div>
      )
    }
  ];

  const handleSelect = (row, eventKey) => {
    const parts = eventKey.split(':');
    if (parts[0] === 'edit') {
      navigate(`/weapons/stock-weapon/edit-stock/${id}/${parts[1]}`, {
        state: { customState: 'stockItem' }
      });
    } else if (parts[0] === 'delete') {
      confirmAlert(row);
    } else if (parts[0] === 'logs') {
      navigate(`/weapons/stock-weapon/stock-logs/${id}/${parts[1]}`, {
        state: { customState: 'stockItem' }
      });
    }
  };

  const confirmAlert = row => {
    Swal.fire({
      title: 'Are you sure?',
      html: `Removal of <b>EPC-${row.epc.slice(-8)} & Serial Nr-${
        row.serial_number
      } </b> from the <b>${itemName} </b> weapon will proceed`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async result => {
      if (result.isConfirmed) {
        await deleteStock(row.id);
      }
    });
  };

  const deleteStock = async stockId => {
    setError([]);
    setLoading(true);

    deleteItemStocks(id, stockId)
      .then(response => {
        if (response.status === 200) loadData();
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleAllClick = () => {
    loadData();
  };

  const tabItems = [
    {
      label: 'All',
      value: 'all',
      count: total,
      onClick: handleAllClick
    }
  ];

  const table = useAdvanceTable({
    data: data
  });

  //const handleSearchInputChange = e => {};

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    switch (type) {
      case 'pagination':
        pagination(page, sizePerPage);
        break;
      case 'sort':
        sort(sortField, sortOrder, data);
        break;
      default:
        break;
    }
  };

  const pagination = (page, sizePerPage) => {
    setCurrentPage(page);
    setPageSize(sizePerPage);
    loadData(page, sizePerPage);
  };

  const sort = (sortField, sortOrder, data) => {
    if (sortColumn === 'desc') {
      setSortColumn('asc');
    } else if (sortColumn === 'asc') {
      setSortColumn('desc');
    }
    setColumnName(sortField);

    if (sortOrder === 'asc') {
      data.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1;
        } else if (b[sortField] > a[sortField]) {
          return -1;
        }
        return 0;
      });
    } else {
      data.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1;
        } else if (b[sortField] > a[sortField]) {
          return 1;
        }
        return 0;
      });
    }
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <h2 className="mb-4">
          {itemName && `Stocks for weapon '${itemName}'`}
        </h2>
        <FilterTab tabItems={tabItems} className="mb-2" />

        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <div className="d-flex flex-wrap gap-3">
              {/* <SearchBox
                placeholder="Search orders"
                onChange={handleSearchInputChange}
              /> */}
              <div className="scrollbar overflow-hidden-y">
                <div className="ms-xxl-auto"></div>
              </div>

              <div className="ms-xxl-auto">
                <Button
                  variant="primary"
                  onClick={() =>
                    navigate(`/weapons/stock-weapon/add-stock-bulk/` + id, {
                      state: { customState: 'stockItem' }
                    })
                  }
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Add Stock - Bulk
                </Button>{' '}
                <Button
                  variant="primary"
                  onClick={() =>
                    navigate(`/weapons/stock-weapon/add-stock/` + id, {
                      state: { customState: 'stockItem' }
                    })
                  }
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Add Stock
                </Button>
              </div>
            </div>
          </div>

          <div>
            {Object.entries(error).length > 0 &&
              error.map((e, index) => (
                <Alert variant="soft-danger" key={index}>
                  {e}
                </Alert>
              ))}
          </div>

          <div className="bg-white border-top border-bottom border-200 position-relative top-1">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: '200px' }}
              >
                <Spinner animation="border" role="status"></Spinner>
              </div>
            ) : (
              <PaginationProvider
                pagination={paginationFactory({
                  custom: true,
                  page: currentPage,
                  sizePerPage: pageSize,
                  totalSize: total,
                  sizePerPageList: [
                    {
                      text: '10',
                      value: 10
                    }
                  ]
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <div>
                    <BootstrapTable
                      remote
                      keyField="id"
                      data={data.length === 0 ? [] : data}
                      columns={columns}
                      bordered={false}
                      onTableChange={handleTableChange}
                      {...paginationTableProps}
                    />
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: '-10px',
                          fontSize: '13px'
                        }}
                      >
                        <PaginationTotalStandalone {...paginationProps} />
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </div>
                  </div>
                )}
              </PaginationProvider>
            )}
          </div>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default StockWeapon;
